const $ = require('jquery');

module.exports = function (popupWindowService, rewardsCardService) {

    const overlayTemplate =
        `<div id="wow-reward-popup" style="z-index: 20001; position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; text-align: center; background: rgba(0, 0, 0, 0.7);">
            <div id="close-overlay" class="bt-close-overlay" style="position: absolute; top: 10px; right: 10px; cursor: pointer; background: url('/Images/PopupDialog/rewards_header_logo.png') -192px 0 no-repeat; height: 18px; width: 18px;"></div>
            <div style="position: relative; top: 50%; max-width: 380px; font-family: HelveticaNeue, HelveticaNeue-Light, 'Helvetica Neue Light', helvetica, arial, sans-serif; font-size: 14px; line-height: 20px; margin: -70px auto 0px;">
                <div style="background: url('/Images/PopupDialog/everyday_rewards_header_logo.png') 0 0 no-repeat; width: 150px; height: 80px; margin: 0px auto 10px; background-size: 100%;"></div>
                <div style="color: rgb(255, 255, 255); margin-bottom: 20px;">Unable to see the secure Everyday Rewards browser? We'll help you reload the window to complete your linking.</div>

                <a id="close-button" class="btn btn-white" cursor: pointer;">Close</a>
                <a id="continue-link" class="btn btn-primary" cursor: pointer;">Relaunch</a>
            </div>
        </div>`;

    const callbacks = {};

    function EDRCardLinkingService() {

    }

    function setWindowFocus() {
        popupWindowService.setFocus();
    }

    function closeOverlay() {
        $('#wow-reward-popup')
            .off('click', '#close-overlay', closeOverlay)
            .off('click', '#continue-link', setWindowFocus)
            .remove();

        popupWindowService.close();
    }

    function checkWindowClosure() {
        if (popupWindowService.isClosed()) {

            if (callbacks['LinkingComplete'.toLowerCase()]) {

                const result = window.WowLinkingResult
                                ? window.WowLinkingResult
                                : null;

                callbacks['LinkingComplete'.toLowerCase()](result);
            }

            closeOverlay();

            return;
        }

        setTimeout(checkWindowClosure, 200);
    }

    function openLinkingWindow() {

        popupWindowService.popupInit('winWowLinking', 500, 350);

        setTimeout(checkWindowClosure, 200);
    }

    EDRCardLinkingService.prototype.init = function () {
        openLinkingWindow();

        rewardsCardService.getLinkingUrl()
            .then((response) => {

                if (response.Success) {
                    $('body').append(overlayTemplate);

                    $('#wow-reward-popup')
                        .on('click', '#close-overlay, #close-button', closeOverlay)
                        .on('click', '#continue-link', setWindowFocus);

                    popupWindowService.setUrl(response.Url);
                    return;
                }

                popupWindowService.setError(response.ErrorMessage);
            });
    };

    EDRCardLinkingService.prototype.setFocus = function () {
        setWindowFocus();
    };

    EDRCardLinkingService.prototype.on = function (eventName, callback) {
        callbacks[eventName.toLowerCase()] = callback;
    };

    EDRCardLinkingService.prototype.off = function (eventName) {
        delete callbacks[eventName.toLowerCase()];
    };

    return new EDRCardLinkingService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/edrcardlinking/edrcard-linking-service.js
 **/